import React from 'react';
import { Link } from 'react-router-dom';

export default function EmployerDashboard(){
  return (
    <div className="bg-background-offwhite min-h-screen py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Employer Dashboard</h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          <div className="bg-white rounded-lg p-6 shadow">
            <div className="text-sm text-gray-500">Active Jobs</div>
            <div className="text-2xl font-bold mt-2">12</div>
          </div>
          <div className="bg-white rounded-lg p-6 shadow">
            <div className="text-sm text-gray-500">Applications</div>
            <div className="text-2xl font-bold mt-2">124</div>
          </div>
          <div className="bg-white rounded-lg p-6 shadow">
            <div className="text-sm text-gray-500">Views (30d)</div>
            <div className="text-2xl font-bold mt-2">3,412</div>
          </div>
        </div>

        <div className="bg-white rounded-lg p-6 shadow">
          <div className="flex items-center justify-between mb-4">
            <h2 className="font-semibold">Recent Activity</h2>
            <Link to="/post-job" className="text-primary-medium font-semibold">Post Job</Link>
          </div>
          <ul className="space-y-3 text-gray-700">
            <li>New application for Frontend Engineer — 2 hours ago</li>
            <li>Your job 'Data Analyst' reached 100 views — yesterday</li>
            <li>Subscription renewal due in 7 days</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
